import React from "react";
import LegalLayout from "./LegalLayout";
import { SITE } from "../config/site";

export default function Privacy() {
  return (
    <LegalLayout
      title="Privacy"
      path="/privacy"
      description="Privacy notice for the Culmora OS pre-launch website."
    >
      <p>
        This notice describes how information is handled on the Culmora OS
        pre-launch website. Privacy notice version {SITE.privacyVersion}.
      </p>
      <h2>What the request form collects</h2>
      <p>
        When you submit the early-access request form, the following is sent to
        our protected submission function and stored in our protected Supabase
        environment: your name, email address, country, user type, main use case,
        team size (where applicable), your Terms and Privacy acknowledgements,
        the applicable legal notice version, optional marketing consent, page
        path, locale, campaign (UTM) values present in the page URL, and a
        session identifier.
      </p>
      <h2>How submissions are protected</h2>
      <p>
        Early-access records are stored in a dedicated, access-controlled
        waitlist table with row-level security enabled. The public website does
        not write directly to that table. Requests are validated, rate-limited
        and inserted only through the protected server-side submission function.
        Cloudflare Turnstile may process request metadata for security
        verification when enabled. Your IP address is never stored in raw form —
        it is converted to a keyed hash on the server for abuse prevention and
        the raw value is discarded.
      </p>
      <h2>How information is used</h2>
      <p>
        Request information is used only to manage early access to Culmora OS
        and, where you explicitly opt in, to send product and availability
        updates. Information is not sold and is not shared with advertisers.
      </p>
      <h2>Where information is stored</h2>
      <p>
        Waitlist records are stored within protected Supabase infrastructure in
        a dedicated waitlist table. The table is not publicly readable or
        writable; public submissions are accepted only through the protected
        server-side function.
      </p>
      <h2>Your rights</h2>
      <p>
        You may request access to, correction of, or deletion of your request
        information at any time by contacting{" "}
        <a href={`mailto:${SITE.contactEmail}`} className="text-[hsl(var(--z-teal))]">
          {SITE.contactEmail}
        </a>
        .
      </p>
      <h2>Analytics and tracking</h2>
      <p>
        No analytics or marketing tracking is active on this website. See the
        Cookies notice for essential technical storage.
      </p>
      <h2>Updates</h2>
      <p>
        This notice will be updated if data practices change. The version
        recorded with your submission identifies the notice you accepted.
      </p>
    </LegalLayout>
  );
}
